<nav class="version-status-update-menu" >
  <div (click)="toggleMenu()">
      <span title="Open Menu"></span>
  </div>

  <ul [hidden]="!open">
    <li *ngIf="versionStatusUpdateAccess && allowedVersionStatus.length>0" class="update-status-li" (click)="toggleStatus()">
      <core-helpers-navigation-three-dots-menu-icon [icon]="'status'"></core-helpers-navigation-three-dots-menu-icon>
      <span class="menu-title" >Change Status</span>
        <core-version-update-status-menu-status-list
          [hidden]="!statusOpen"
          [status]="allowedVersionStatus"
          (action)="onStatusMenuSelect($event)"
        ></core-version-update-status-menu-status-list>
    </li>
    <li *ngFor="let item of menu | sortByMenuOrder" (click)="onMenuClick(item.key)">
      <core-helpers-navigation-three-dots-menu-icon [icon]="item.icon"></core-helpers-navigation-three-dots-menu-icon>
      <span class="menu-title" >{{item.title}}</span>
    </li>
  </ul>
</nav>